import React, { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { BusFront, ArrowRight, Clock, Users } from "lucide-react";
import { Layout } from "../components/Layout";
import { useI18n } from "../i18n";
import { eur } from "../lib/format";
import * as apiClient from "../api";

const VEHICLES = { taxi: "Taxi", ncc: "NCC", minivan: "Minivan", bus: "Bus", private: "Transfer privato" };

export default function Transfers() {
  const { t } = useI18n();
  const { data: all = [] } = useQuery({ queryKey: ["transfers"], queryFn: apiClient.getTransfers });
  const { data: settings } = useQuery({ queryKey: ["publicSettings"], queryFn: apiClient.getPublicSettings });
  const [search, setSearch] = useState({ from_loc: "", to_loc: "", people: 2 });
  const [results, setResults] = useState(null);

  const run = async (e) => {
    e.preventDefault();
    const r = await apiClient.searchTransfers(search);
    setResults(r);
  };
  const list = results ?? all;

  return (
    <Layout>
      <div className="bg-gradient-to-b from-primary to-[#003A69] text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12">
          <div className="text-xs font-bold uppercase tracking-[0.2em] text-secondary mb-2 flex items-center gap-2"><BusFront className="h-4 w-4" /> Transfer</div>
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-heading font-semibold tracking-tight">Transfer & Trasporti</h1>
          <p className="text-white/70 mt-2">Aeroporti, stazioni, spiagge e porti del Gargano.</p>
          <form onSubmit={run} className="mt-6 glass rounded-2xl p-3 grid grid-cols-1 sm:grid-cols-4 gap-3">
            <input data-testid="transfer-from" placeholder="Da (es. Bari)" value={search.from_loc} onChange={(e) => setSearch({ ...search, from_loc: e.target.value })} className="rounded-xl bg-white/90 px-4 py-3 text-sm text-slate-800 outline-none" />
            <input data-testid="transfer-to" placeholder="A (es. Vieste)" value={search.to_loc} onChange={(e) => setSearch({ ...search, to_loc: e.target.value })} className="rounded-xl bg-white/90 px-4 py-3 text-sm text-slate-800 outline-none" />
            <input data-testid="transfer-people" type="number" min="1" value={search.people} onChange={(e) => setSearch({ ...search, people: Number(e.target.value) })} className="rounded-xl bg-white/90 px-4 py-3 text-sm text-slate-800 outline-none" />
            <button data-testid="transfer-search-btn" className="rounded-xl bg-white text-primary font-semibold px-6 py-3">Cerca</button>
          </form>
        </div>
      </div>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 py-10 space-y-4">
        {list.map((tr) => (
          <div key={tr.id} data-testid={`transfer-item-${tr.id}`} className="rounded-2xl border border-slate-100 p-5 bg-white shadow-sm hover-lift flex flex-col sm:flex-row sm:items-center gap-4">
            <div className="flex-1 flex items-center gap-3 font-heading font-semibold text-slate-900">
              <span>{tr.from_loc}</span><ArrowRight className="h-4 w-4 text-secondary" /><span>{tr.to_loc}</span>
            </div>
            <div className="flex items-center gap-4 text-sm text-slate-500">
              <span className="rounded-full bg-slate-100 px-3 py-1 text-xs font-semibold">{VEHICLES[tr.vehicle]}</span>
              <span className="flex items-center gap-1"><Clock className="h-3.5 w-3.5" />{tr.duration_min}min</span>
              <span className="flex items-center gap-1"><Users className="h-3.5 w-3.5" />{tr.max_people}</span>
            </div>
            <div className="text-right">
              <div className="font-heading font-bold text-lg text-primary">{eur(tr.price)}</div>
              {settings?.whatsapp ? (
                <a href={`https://wa.me/${String(settings.whatsapp).replace(/[^\d]/g, "")}?text=Richiesta%20transfer%20Cristalda`} target="_blank" rel="noopener noreferrer" className="text-xs font-semibold text-secondary">Richiedi</a>
              ) : settings?.email ? (
                <a href={`mailto:${settings.email}?subject=Richiesta%20transfer`} className="text-xs font-semibold text-secondary">Richiedi</a>
              ) : null}
            </div>
          </div>
        ))}
        {list.length === 0 && <p className="text-center text-slate-400 py-10">Nessun transfer trovato.</p>}
      </div>
    </Layout>
  );
}
